import { RegistrationType } from '../types/registrationTypes';

/**
 * State interface for the registration slice
 */
export interface RegistrationSliceState {
  /** Current registration being viewed/edited (renamed from registration) */
  currentRegistration: RegistrationType | null;
  /** Whether the registration has been edited */
  isEdited: boolean;
  /** Set of field paths that have been edited */
  editedFields: string[];
  /** Validation errors keyed by field path */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the registration slice
 */
export const initialState: RegistrationSliceState = {
  currentRegistration: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
